/* tslint:disable */
/* eslint-disable */
/**
 * API SPECS
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { InfantAfterOneWeek } from './InfantAfterOneWeek';
import {
    InfantAfterOneWeekFromJSON,
    InfantAfterOneWeekFromJSONTyped,
    InfantAfterOneWeekToJSON,
} from './InfantAfterOneWeek';
import type { PaginationInfo } from './PaginationInfo';
import {
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
} from './PaginationInfo';

/**
 * 
 * @export
 * @interface InfantAfterOneWeekPagination
 */
export interface InfantAfterOneWeekPagination {
    /**
     * 
     * @type {Array<InfantAfterOneWeek>}
     * @memberof InfantAfterOneWeekPagination
     */
    data?: Array<InfantAfterOneWeek>;
    /**
     * 
     * @type {PaginationInfo}
     * @memberof InfantAfterOneWeekPagination
     */
    meta?: PaginationInfo;
}

/**
 * Check if a given object implements the InfantAfterOneWeekPagination interface.
 */
export function instanceOfInfantAfterOneWeekPagination(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function InfantAfterOneWeekPaginationFromJSON(json: any): InfantAfterOneWeekPagination {
    return InfantAfterOneWeekPaginationFromJSONTyped(json, false);
}

export function InfantAfterOneWeekPaginationFromJSONTyped(json: any, ignoreDiscriminator: boolean): InfantAfterOneWeekPagination {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(InfantAfterOneWeekFromJSON)),
        'meta': !exists(json, 'meta') ? undefined : PaginationInfoFromJSON(json['meta']),
    };
}

export function InfantAfterOneWeekPaginationToJSON(value?: InfantAfterOneWeekPagination | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(InfantAfterOneWeekToJSON)),
        'meta': PaginationInfoToJSON(value.meta),
    };
}

